import services from './../../services/service'; // Service Class
import MainHeader from './../MainHeader/index.vue'; // Main Header
import MainFooter from './../MainFooter/index.vue'; // Main Footer
import ProductList from '../../components/product/ProductList.vue'

let service = new services();

export default {
    name: 'Home',
    data () {
        return {
            products: {},
            product: {},
            items:[],
            checked_out_items: [],
           img_url: service.imageURL
        }
    },
  
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter,
        'product-list': ProductList
    },
    computed: {
        total() {
          var total = 0;
          for(var i = 0; i < this.items.length; i++) {
            total += this.items[i].product_price;
          }
          return total;
        }
    },
    methods: {
        getProducts() {
            service.getProducts(this).then(data => {
                if(data.body.status == 200) {
                    this.products = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                     //toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },
        addToCart(item) {
            item.quantity = 0;
            item.quantity += 1;

            item.checked_out = false; //prepare for checkout
            this.items.push(item);
         },
        removeFromCart(item) {
            item.quantity -= 1;
            this.items.splice(this.items.indexOf(item), 1);
        },
        checkout() {
            //currently processi =ng the whole items
            //--in most cases users select the items they want to check out
            this.items.forEach(function(element) {
                element.checked_out = true;
            }, this);
            this.checked_out_items = this.items;
            this.items = [];
        },

        
    },
    created: function(){
        //this.getProducts();
    }
}


// WEBPACK FOOTER //
// ./src/pages/Home/script.js